module.exports = __webpack_public_path__ + "static/step-1@2x-f39e7d0d055af53586bcbe086655a867.png";